<template>
  <div>
    <h1>404 - Not Found</h1>
    <p>The requested URL was not found on this server.</p>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
/* Add your custom styles here */
</style>
